"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientNotificationAlertDismissal_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PatientNotification_1 = require("./PatientNotification");
var User_1 = require("./User");
var PatientNotificationAlertDismissal_Factory = /** @class */ (function () {
    function PatientNotificationAlertDismissal_Factory() {
    }
    PatientNotificationAlertDismissal_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            LastDismissedDate: Date_Factory_1.Date_Factory.CreateIncoming(model.LastDismissedDate, { ignoreTimePortion: true }),
            PatientNotification: PatientNotification_1.PatientNotification_Factory.CreateIncoming(model.PatientNotification),
            PatientNotificationId: model.PatientNotificationId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            User: User_1.User_Factory.CreateIncoming(model.User),
            UserId: model.UserId,
        };
        return result;
    };
    PatientNotificationAlertDismissal_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            LastDismissedDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.LastDismissedDate, { ignoreTimePortion: true }),
            PatientNotification: PatientNotification_1.PatientNotification_Factory.CreateOutgoing(model.PatientNotification),
            PatientNotificationId: model.PatientNotificationId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            User: User_1.User_Factory.CreateOutgoing(model.User),
            UserId: model.UserId,
        };
        return result;
    };
    return PatientNotificationAlertDismissal_Factory;
}());
exports.PatientNotificationAlertDismissal_Factory = PatientNotificationAlertDismissal_Factory;
